import React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../../Store/rootReducer';
import styles from './_ticket-submission.module.scss';


const FIRST_NAME_SEARCH_VALUE = 'REPLACE_FIRST_NAME';
const LAST_NAME_SEARCH_VALUE = 'REPLACE_LAST_NAME';
const EMAIL_SEARCH_VALUE = 'REPLACE_EMAIL';
const REPLACE_PRODUCT_NAME = 'REPLACE_PRODUCT_NAME';

export default function TicketSubmission() {
  const currentUser = useSelector((state: AppState) => state.shared.currentUser);
  // Get generic ticket submission url
  const helpDeskUrl: string | null = 'https://forms.zohopublic.com/edean/form/SubmitaTicket/formperma/xGVIhCjkcRzgZs7R_IxAoHZtUqm7Vtjt_r6LvlGSUtY?Name_First=REPLACE_FIRST_NAME&Name_Last=REPLACE_LAST_NAME&Email=REPLACE_EMAIL&Dropdown1=REPLACE_PRODUCT_NAME';
  // Create unique url for the current user
  const ticketSubmissionUrl: string = helpDeskUrl 
    ? helpDeskUrl
      .replace(FIRST_NAME_SEARCH_VALUE, currentUser?.firstName ?? "")
      .replace(LAST_NAME_SEARCH_VALUE, currentUser?.lastName ?? "")
      .replace(EMAIL_SEARCH_VALUE, currentUser?.emailAddress ?? "")
      .replace(REPLACE_PRODUCT_NAME, "NIADA")

    : '';
  return (
    <div id='ticketSubmission' className={styles.ticketSubmissionContainer}>
      <iframe
        frameBorder='0'
        height='100%'
        width='100%'
        className={styles.iFrame}
        src={ticketSubmissionUrl}
      ></iframe>
    </div>
  );
}
